import React from 'react';
import { animated, useSpring } from 'react-spring';

const MockupView = ({ start }) => {
  const mockupProps = useSpring({
    config: {
      mass: 20,
      friction: 100,
    },
    opacity: start ? 1 : 0,
    transform: `translate(0, ${
      start ? -window.innerHeight / 10 + 'px' : window.innerHeight + 'px'
    })`,
  });

  return <animated.div style={mockupProps} className="mockup"></animated.div>;
};

export default MockupView;
